import { createAction, props } from '@ngrx/store';
import { ShipmentHeader } from '../../models/shipment-header';
import { ShipmentQuery } from '../../models/shipment-query';
import { ShipmentStatusEnum } from '../../enum/shipment-status.enum';

export const shipmentTableRequest = createAction(
    '[Shipment Table] Load Request'
);

export const shipmentTableSuccess = createAction(
    '[Shipment Table] Load Response',
    props<{ totalCount: number, page: ShipmentHeader[] }>()
);

export const shipmentTableFailure = createAction(
    '[Shipment Table] Load Failure'
);

export const shipmentTableChangePage = createAction(
    '[Shipment Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const shipmentTableChangeQuery = createAction(
    '[Shipment Table] Change Filter',
    props<{ query: ShipmentQuery }>()
);

export const shipmentTableAddAssist = createAction(
    '[Shipment Table] Add Filter Assist',
    props<{ id: string, parameters: any }>()
);

export const shipmentTableRemoveAssist = createAction(
    '[Shipment Table] Remove Filter Assist',
    props<{ id: string }>()
);

export const shipmentTableSetSelection = createAction(
    '[Shipment Table] Set Selection',
    props<{ ids: string[] }>()
);

export const shipmentTableToggle = createAction(
    '[Shipment Table] Toggle Single Selection',
    props<{ id: string }>()
);

export const shipmentTableMasterToggle = createAction(
    '[Shipment Table] Master Toggle Selection'
);

export const shipmentTableSort = createAction(
    '[Shipment Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const shipmentTableSetColumns = createAction(
    '[Shipment Table] Change Columns',
    props<{ columns: string[] }>()
);

export const shipmentTableCreateView = createAction(
  '[Shipment Table] Create View',
  props<{ name: string }>()
);

export const shipmentTableDeleteView = createAction(
    '[Shipment Table] Delete View',
    props<{ id: string }>()
);

export const shipmentTableUpdatePreSelectedQuote = createAction(
    '[Shipment Table] Change Pre-Selected Quote',
    props<{ shipmentId: string, quoteId: string }>()
);

export const shipmentTableUpdateComplete = createAction(
    '[Shipment Table] Update Complete for Shipment',
    props<{ shipmentId: string }>()
);

export const shipmentTableUpdateFailure = createAction(
    '[Shipment Table] Update Failed for Shipment',
    props<{ shipmentId: string }>()
);

export const shipmentTableUpdateStatuses = createAction(
    '[Shipment Table] Change State for Shipments',
    props<{ shipmentIds: string[], newState: ShipmentStatusEnum}>()
);

